/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API18788Item {
  
  /** 资源父id */
  resourceParentId?: number;
  
  /** 菜单名称 */
  name?: string;
  
  /** icon */
  icon?: string;
  
  /** 跳转url */
  url?: string;
  
  /** 排序 */
  sort?: number;
  
  /** 菜单层级 */
  level?: number;
  
  /** 1启用 0禁用 */
  status?: string;
  
  /** 备注 */
  remark?: string;
  
  /** ResourceMenuDto */
  childMenus?: undefined[];
  
  /** 菜单id */
  resourceId?: string;
  
  /** MENU ACTION BUTTON */
  resourceType?: string;
  
  /** PUBLISH PRIVATE */
  isPublish?: string;
  
};
    
  



export interface API18788Req {
  
  /** 项目id */
  projectId: string;
    
};



export interface API18788Res {
  /** ResourceMenuDto  */
  list?: API18788Item[];
  /** 总数  */
  totalNumber?: string;
  
};


// 18788 获取菜单接口

export interface IUseGetAPI18788Return {
  /** 获取菜单接口: 接口请求状态 */
  isAPI18788Loading: boolean;
  /** 获取菜单接口: 接口请求返回数据 */
  dataAPI18788: API18788Res;
  /**  获取菜单接口: 接口数据请求方法 */
  fetchAPI18788Data:  (inputs: API18788Req, config?: YWRequestConfig) => Promise<API18788Res>;
  /** 获取菜单接口: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI18788 = ():IUseGetAPI18788Return => {
  let isMount = true;
  const [isAPI18788Loading, setIsAPI18788Loading] = useState(false);
  const [dataAPI18788, setDataAPI18788] = useState<API18788Res>({} as API18788Res);
  const requestUrl = `${basePath}/ywwl-admin/auth/user/menu`;

  const fetchAPI18788Data = async (inputs: API18788Req, config?: YWRequestConfig): Promise<API18788Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API18788Req>) || {}) as API18788Req;
    
  
    if ( isMount ) {
      setIsAPI18788Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API18788Res>(`${basePath}/ywwl-admin/auth/user/menu?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI18788(res || {} as API18788Res);
        setIsAPI18788Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI18788Loading(false);
      }
      return false as unknown as API18788Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI18788Loading,
    dataAPI18788,
    fetchAPI18788Data,
    requestUrl,
  }
}

